import { render, staticRenderFns } from "./compras.vue?vue&type=template&id=7540f413&"
import script from "./compras.vue?vue&type=script&lang=js&"
export * from "./compras.vue?vue&type=script&lang=js&"
import style1 from "./compras.vue?vue&type=style&index=1&id=7540f413&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports